import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 18H18V15H20V18C20 18.55 19.8038 19.0204 19.4121 19.4121C19.0204 19.8038 18.55 20 18 20H6C5.45 20 4.97956 19.8038 4.58789 19.4121C4.19622 19.0204 4 18.55 4 18V15H6V18ZM17 9L15.5996 10.4502L13 7.84961V16H11V7.84961L8.40039 10.4502L7 9L12 4L17 9Z" })
});
export default SvgUpload;
